import React from 'react';
import TechWork from '../components/sections/TechWork/TechWork';

type FeatureProps = {
  description: string;
};

export const FEATURE_COMPONENTS: Record<string, React.FC<FeatureProps>> = {
  'maintenance-mode': TechWork,
};
